<template>
  <div class="page">
    <van-nav-bar title="请假申请" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-tabs type="line" v-model="active" animated color="#0088F8" @click="tabsChange">
      <van-tab title="请假申请">
        <van-form @submit="onSubmit" style="height: calc(100vh - 100px)">
          <van-field style="margin-top: 10px" readonly clickable name="calendar" :value="form.kssj" label="开始时间" input-align="right" is-link error-message-align="right" placeholder="请选择" @click="$refs.startTime.showCalendar = true" :rules="[{ required: true, message: '请选择开始时间' }]" />
          <van-field readonly clickable name="结束时间" :value="form.jssj" label="结束时间" input-align="right" is-link error-message-align="right" placeholder="请选择" @click="$refs.endTime.showCalendar = true" :rules="[{ required: true, message: '请选择结束时间' }]" />
          <van-field v-model="form.qjsc" readonly name="请假时长" label="免签时长" input-align="right" error-message-align="right" placeholder="请输入" :rules="[{ required: true, message: '请填写免签时长' }]" />
          <van-field style="margin-top: 10px" class="textarea" v-model="form.sqsy" show-word-limit maxlength="200" rows="5" autosize label="请假事由" type="textarea" placeholder="请输入" :rules="[{ required: true, message: '请输入请假事由' }]" />
          <van-field name="uploader" label="证明材料">
            <template #input>
              <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
            </template>
          </van-field>
          <div class="button-box">
            <van-button round type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="请假记录">
        <div class="empty" v-if="showEmpty">
          <img src="../../../../assets/images/sx_empty.png" alt="" />
          <div>暂无请假申请</div>
          <div class="button" @click="active = 0">
            立即申请
          </div>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else style="padding-bottom: 100px">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="item-box" v-for="(item, index) in list" :key="index" @click="$router.push({ path: `/internship/applyStatus?config=5&qjid=${item.qjid}` })">
              <div class="title-line">
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ item.sqrq }}</div>
              </div>
              <div class="date">单位名称: {{ item.qymc }}</div>
              <div class="date">开始时间: {{ item.kssj }}</div>
              <div class="date">结束时间: {{ item.jssj }}</div>
              <div class="date">请假时长: {{ item.qjsc }} 天</div>
              <div class="tip-box">
                <div class="status" :style="{ borderColor: getStatusColor(item.iswfmes), color: getStatusColor(item.iswfmes) }">{{ getStatusText(item.iswfmes) }}</div>
                <!-- <p>提醒审批</p> -->
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <!-- 选择开始时间 -->
    <date-time-picker ref="startTime" @done="onConfirm1"></date-time-picker>
    <!-- 选择开始时间 -->
    <date-time-picker ref="endTime" @done="onConfirm2"></date-time-picker>
    <reviewer-dialog :code="965" @change="reviewerChange" ref="dialog" @done="saveData()"></reviewer-dialog>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import ReviewerDialog from './components/reviewerDialog.vue'
import DateTimePicker from './components/dateTimePicker.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    ReviewerDialog,
    DateTimePicker,
  },
  data() {
    return {
      isEdit: false,
      active: 0,
      page: 1,
      pageSize: 10,
      fileList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      showEmpty: false,
      showCalendar: false,
      showEndCalendar: false,
      columnsValue: '上午',
      columns: ['上午', '下午'],
      form: {
        kssj: '',
        jssj: '',
        qjsc: '',
        sqsy: '',
        sqzp: '',
        xnxq01id: '',
        userid: '',
        type: 'add',
        mqid: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
    // 审核状态：0-未通过，1-通过，2-审核中，3-待送审，4-终止流程
    getStatusColor() {
      return status => {
        let color = ['#F85352', '#41B29C', '#FFA400', '#FFA400', '#B2B2B2']
        return color[parseInt(status)]
      }
    },
    getStatusText() {
      return status => {
        let text = ['未通过', '通过', '审核中', '待送审', '终止流程']
        return text[parseInt(status)]
      }
    },
  },
  methods: {
    onConfirm1(data) {
      if (this.form.jssj != '') {
        let date = new Date(data.split(' ')[0]).getTime()
        let jssj = new Date(this.form.jssj.split(' ')[0]).getTime()
        if (date > jssj) {
          this.$toast('开始时间不能大于结束时间')
          return
        }
      }
      this.form.kssj = data
      this.computeTime()
    },
    onConfirm2(data) {
      if (this.form.kssj != '') {
        let date = new Date(data.split(' ')[0]).getTime()
        let kssj = new Date(this.form.kssj.split(' ')[0]).getTime()
        if (date < kssj) {
          this.$toast('结束时间不能小于开始时间')
          return
        }
      }
      this.form.jssj = data
      this.computeTime()
    },
    computeTime() {
      if (this.form.kssj != '' && this.form.jssj != '') {
        let startTime = new Date(this.form.kssj.split(' ')[0])
        let endTime = new Date(this.form.jssj.split(' ')[0])
        let day = Math.floor((endTime - startTime) / 1000 / 60 / 60 / 24) + 1
        if (this.form.kssj.split(' ')[1] == '下午') {
          day -= 0.5
        }
        if (this.form.jssj.split(' ')[1] == '上午') {
          day -= 0.5
        }
        this.form.qjsc = day
      }
    },
    tabsChange(e) {},
    reviewerChange(e) {
      this.form.userid = e
    },
    upload(e) {
      this.form.sqzp = e.file
    },
    onSubmit() {
      this.$refs.dialog.open()
    },
    async saveData() {
      if(this.form.userid == null || this.form.userid == ''){
        this.$toast.fail("请选择审核人!");
        return null;
      }
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postAskLevel(this.form)
      if (res.code == '1') {
        this.$toast(res.msg)
        for (const name in this.form) {
          if (this.form.hasOwnProperty(name)) {
            if (this.form[name]) {
              this.form[name] = ''
            }
          }
        }
        if (!this.isEdit) {
          this.fileList = []
          await this.onRefresh()
          this.active = 1
        } else {
          this.$toast.success('重新申请成功')
          this.fileList = []
          await this.onRefresh()
          this.active = 1
          // setTimeout(() => {
          //   this.$router.go(-2)
          // }, 800)
        }
      }
    },
    async onLoad() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const res = await iApi.getAskLevelList({
        page: this.page,
        size: this.pageSize,
        sxjhid:this.sxjhid
      })
      this.list = this.list.concat(res.data)
      this.list.splice(0, 0)
      this.loading = false
      if (res.data.length < this.pageSize) {
        this.finished = true
      } else {
        this.page += 1
      }
      if (this.list.length == 0) {
        this.showEmpty = true
      } else {
        this.showEmpty = false
      }
    },
    onRefresh() {
      // 清空列表数据
      this.list = []
      this.page = 1
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    async getReDetail(id) {
      const res = await iApi.getAskLevelList({ qjid: id })
      this.form = {
        kssj: res.data.kssj,
        jssj: res.data.jssj,
        qjsc: res.data.qjsc,
        sqsy: res.data.sqsy,
        sqzp: '',
        xnxq01id: res.data.xnxq01id,
        userid: '',
        type: 'edit',
        qjid: id,
      }
      this.fileList.push({
        content: res.data.filebase64,
      })
    },
  },
  created() {
    if (this.$route.query.isEdit) {
      this.isEdit = true
      this.active = 0
      this.getReDetail(this.$route.query.qjid)
    }
    // this.onLoad()
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  position: relative;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
.textarea{
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/askLevelList.vue